import { Stack, Button, Box, Grid, IconButton } from "@mui/material";
import React from "react";
import { useHistory, useParams, useLocation } from "react-router";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";

//Individual Card Component

function Reports({
  singleSpaceInfo,
  hotelId,
  setOpenConfiguration,
  setGridRefresh,
}) {
  const Card = ({ name, description, id }) => {
    const url = new URL(window.location.href);
    const { shopId, shopName, shopType } = useParams();
    const history = useHistory();
    const location = useLocation();

    // set the links while creating the drawer
    const constructPathName = (id) => {
      return `/space-report/${id}/`;
    };

    return (
      <div className="cardes">
        <div className="card-bodys">
          <h2>{name}</h2>
          <p>{description}</p>
        </div>
        <div>
          <Button
            variant="custom-button"
            style={{
              display: "block",
              marginLeft: "auto",
              marginRight: "1rem",
              marginBottom: "1rem",
            }}
            // onClick={() =>
            //   history.push({
            //     pathname: constructPathName(id),
            //     search: `?hotelId=${hotelId}`,
            //     state: { index: location.state.index },
            //   })
            // }
            onClick={() => {
              const url = `${constructPathName(id)}?hotelId=${hotelId}`;
              window.open(url, "_blank");
            }}
          >
            View
          </Button>
        </div>
      </div>
    );
  };

  const reports = [
    {
      name: "Order wise sales summary",
      description: "Get the summary of Order Wise Sales Summary Report",
      id: "5",
      access: true,
    },
    // {
    //   name: `${t("KOT modification")}`,
    //   description: `${t(
    //     "Get the summary of all the KOT modifications made for the shop"
    //   )}`,
    //   id: "6",
    //   access: true,
    // },
    // {
    //   name: `${t("KOT report")}`,
    //   description: `${t(
    //     "Get the summary of all the KOTs punched for the shop"
    //   )}`,
    //   id: "7",
    //   access: true,
    // },
    // {
    //   name: `${t("Daywise item sales summary report")}`,
    //   description: `${t(
    //     "Get the summary of all the item punched in a day for the shop"
    //   )}`,
    //   id: "8",
    //   access: true,
    // },
  ];
  return (
    <Box sx={{ width: 1080, p: 2 }}>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "flex-end",
          mb: 2,
        }}
      >
        <IconButton onClick={() => setOpenConfiguration(false)}>
          <HighlightOffIcon />
        </IconButton>
      </Box>
      <Grid container spacing={2}>
        {reports.map((e) => (
          <Grid item xs={12} sm={6} md={4}>
            <Card id={e.id} name={e.name} description={e.description} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}

function mapStateToProps(state) {
  return {
    data: state.auth.selectedHotel,
    shopAccessControl: state.auth.shopAccessControl,
  };
}
export default connect(mapStateToProps)(Reports);
